/*
 * KNSAIX LiD semantic translation overrides.
 *
 * These entries are deterministic, manually verified corrections
 * for question/language combinations where the generic learning
 * pairing is insufficient.
 *
 * Runtime model inference: none.
 */

export type LidSemanticTranslationTone =
  | 'shared'
  | 'signal'
  | 'trap'
  | 'semantic';


export interface LidSemanticTranslationPair {
  german: string;
  translated: string;
  tone: LidSemanticTranslationTone;
}


export const STATIC_QUESTION_TRANSLATION_PAIRS:
  Record<string, LidSemanticTranslationPair[]> = {
  'lid:general:DE:1|tr': [
    {
      german: 'In Deutschland',
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: 'dürfen',
      translated: 'edebilir',
      tone: 'semantic',
    },
    {
      german: 'Menschen',
      translated: 'insanlar',
      tone: 'semantic',
    },
    {
      german: 'offen',
      translated: 'açıkça',
      tone: 'semantic',
    },
    {
      german: 'etwas',
      translated: 'görüşlerini',
      tone: 'semantic',
    },
    {
      german: 'gegen',
      translated: 'karşı',
      tone: 'semantic',
    },
    {
      german: 'Regierung',
      translated: 'hükümete',
      tone: 'semantic',
    },
    {
      german: 'sagen',
      translated: 'ifade',
      tone: 'semantic',
    },
    {
      german: 'weil',
      translated: 'çünkü',
      tone: 'semantic',
    },
  ],

  'lid:general:DE:1|vi': [
    {
      german: 'In Deutschland',
      translated: 'Ở Đức',
      tone: 'semantic',
    },
    {
      german: 'dürfen',
      translated: 'có thể',
      tone: 'semantic',
    },
    {
      german: 'Menschen',
      translated: 'người dân',
      tone: 'semantic',
    },
    {
      german: 'offen',
      translated: 'công khai',
      tone: 'semantic',
    },
    {
      german: 'gegen die Regierung',
      translated: 'phản đối chính phủ',
      tone: 'semantic',
    },
    {
      german: 'sagen',
      translated: 'lên tiếng',
      tone: 'semantic',
    },
    {
      german: 'weil',
      translated: 'vì',
      tone: 'semantic',
    },
  ],

  'lid:general:DE:102|en': [
    {
      german: 'in der Bundesrepublik Deutschland',
      translated: 'in the Federal Republic of Germany',
      tone: 'semantic',
    },
    {
      german: 'Bundesrepublik',
      translated: 'Federal Republic',
      tone: 'semantic',
    },
  ],

  'lid:general:DE:103|tr': [
    {
      german: 'in Deutschland',
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: 'Ampelkoalition',
      translated:
        '"trafik ışığı koalisyonu" (Ampelkoalition)',
      tone: 'semantic',
    },
    {
      german: 'Was',
      translated: 'neyi',
      tone: 'semantic',
    },
    {
      german: 'bezeichnet',
      translated: 'ifade eder',
      tone: 'semantic',
    },
  ],

  'lid:general:DE:235|tr': [
    {
      german: 'französische Staatspräsident',
      translated: 'Fransa Cumhurbaşkanı',
      tone: 'semantic',
    },
    {
      german: 'deutsche Bundeskanzler',
      translated: 'Almanya Federal Başbakanı',
      tone: 'semantic',
    },
    {
      german: 'in Verdun',
      translated: "Verdun'da",
      tone: 'semantic',
    },
    {
      german: 'gemeinsam',
      translated: 'birlikte',
      tone: 'semantic',
    },
    {
      german: 'Toten',
      translated: 'ölenleri',
      tone: 'semantic',
    },
    {
      german: 'beider Weltkriege',
      translated: 'iki dünya savaşında',
      tone: 'semantic',
    },
    {
      german: 'Welches Ziel',
      translated: 'hangi amacı',
      tone: 'semantic',
    },
    {
      german: 'der Europäischen Union',
      translated: "Avrupa Birliği'nin",
      tone: 'semantic',
    },
    {
      german: 'bei diesem Treffen',
      translated: 'Bu buluşmada',
      tone: 'semantic',
    },
    {
      german: 'deutlich',
      translated: 'görülür',
      tone: 'semantic',
    },
  ],

  'lid:general:DE:267|tr': [
    {
      german: 'Eine junge Frau',
      translated: 'genç bir kadın',
      tone: 'semantic',
    },
    {
      german: 'in Deutschland',
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: '22 Jahre alt',
      translated: '22 yaşındaki',
      tone: 'semantic',
    },
    {
      german: 'lebt',
      translated: 'yaşıyor',
      tone: 'semantic',
    },
    {
      german: 'mit ihrem Freund zusammen',
      translated: 'erkek arkadaşıyla birlikte',
      tone: 'semantic',
    },
    {
      german: 'Die Eltern der Frau',
      translated: 'Anne-babası',
      tone: 'semantic',
    },
    {
      german: 'der Freund',
      translated: 'erkek arkadaşını',
      tone: 'semantic',
    },
    {
      german: 'nicht gefällt',
      translated: 'sevmediği',
      tone: 'semantic',
    },
    {
      german: 'weil',
      translated: 'için',
      tone: 'semantic',
    },
    {
      german: 'Was',
      translated: 'ne',
      tone: 'semantic',
    },
    {
      german: 'die Eltern',
      translated: 'Anne-baba',
      tone: 'semantic',
    },
    {
      german: 'tun',
      translated: 'yapabilir',
      tone: 'semantic',
    },
  ],
};

